const DEFAULT_MAX_LABEL_LENGTH = 24;

export function truncateAxisLabel(
  label: string,
  maxLength: number = DEFAULT_MAX_LABEL_LENGTH
): string {
  if (maxLength <= 0 || label.length <= maxLength) {
    return label;
  }

  const graphemes = [...label];
  if (graphemes.length <= maxLength) {
    return label;
  }

  if (maxLength <= 1) {
    return '…';
  }

  return `${graphemes.slice(0, maxLength - 1).join('')}…`;
}
